<header>
  <nav class="navbar navbar-expand-md navbar-dark bg-dark">
    <a class="navbar-brand mr-3"
       routerLink="/home">
      <img src="assets/images/brand/{{configuration.siteInfo.brandName}}/{{configuration.siteInfo.imageName}}">
      <span class="aqx-title aqx-color-primary ml-2">
        {{title}}
      </span>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse"
         id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item"
            routerLinkActive="active">
          <a class="nav-link"
             routerLink="/home">
            Home
          </a>
        </li>
        <li class="nav-item"
            routerLinkActive="active">
          <a class="nav-link"
             routerLink="/apis">
            APIs
          </a>
        </li>
        <li class="nav-item"
            routerLinkActive="active"
            *ngIf="isUserEntitledApiStore">
          <a class="nav-link"
             routerLink="/subscriptions">
            My Subscriptions
          </a>
        </li>
        <li class="nav-item dropdown"
            routerLinkActive="active"
            *ngIf="configuration.siteInfo.siteFeatures.showAboutMenu">
          <a class="nav-link dropdown-toggle"
             href=""
             id="navbarDropdownAbout"
             role="button"
             data-toggle="dropdown"
             aria-haspopup="true"
             aria-expanded="false">
            About
          </a>
          <div class="dropdown-menu"
               style="opacity: inherit;"
               aria-labelledby="navbarDropdownAbout">
            <a class="dropdown-item"
               routerLink="/about-platform">
              The Aqaix API Platform
            </a>
            <a class="dropdown-item"
               routerLink="/about-standards">
              Open Standards
            </a>
            <a class="dropdown-item"
               routerLink="/about-aqaix">
              About Aqaix
            </a>
            <a class="dropdown-item"
               routerLink="/about-buy">
              Buy Now
            </a>
            <!--<a class="dropdown-item"-->
               <!--routerLink="/about-blog">-->
              <!--Blog-->
            <!--</a>-->
          </div>
        </li>
      </ul>
      <aqx-user></aqx-user>
    </div>
  </nav>
</header>
<aqx-message></aqx-message>
<div class="mt-3"
     style="min-height: 700px">
  <aqx-breadcrumb></aqx-breadcrumb>
  <router-outlet></router-outlet>
</div>
